import * as React from "react";
const SvgDownArrowIconsTriangleDownFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#2175D9", fillRule: "evenodd", d: "M2.112 6.994Q2 6.874 2 6.636q0-.278.188-.457A.62.62 0 0 1 2.638 6h10.725q.262 0 .45.179.187.18.187.457a.44.44 0 0 1-.113.319l-.075.119-5.1 6.204q-.337.358-.712.358t-.713-.358l-5.1-6.204z" }));
export default SvgDownArrowIconsTriangleDownFill;
